<script>

	import { onMount } from 'svelte';
	import { format, addMinutes, subMinutes, addHours, subHours, addSeconds, setSeconds, setMilliseconds, differenceInMilliseconds } from 'date-fns'

	import Spinner from './widgets/Spinner.svelte'

	const timeFormat = 'HH:mm:ss';

	let startTime = setMilliseconds(new Date(), 0);
	let endTime = startTime;
	let hourRate = 100;
	let currency = '€';
	let moneyPrecission = 2;

	let timer

	$: duration = differenceInMilliseconds(endTime, startTime); // endTime - startTime
	$: durationHours = Math.floor(duration / (60*60*1000));
	$: durationMinutes = Math.floor((duration - (durationHours*60*60*1000)) / (60*1000));
	$: durationSeconds = Math.floor((duration - (durationHours*60*60*1000) - (durationMinutes*60*1000)) / 1000)
	$: durationFormatted = durationHours.toString().padStart(2, '0') + ':' + durationMinutes.toString().padStart(2, '0') + ':' + durationSeconds.toString().padStart(2, '0');
	$: total = (duration * hourRate / (60*60*1000)).toFixed(moneyPrecission);

	onMount(() => {
		startTimer();
		requestWakeLock();
		return () => {
			stopTimer()
		};
	});

	async function requestWakeLock() {
		try {
			let wakeLock = await navigator.wakeLock.request('screen');
			wakeLock.addEventListener('release', () => {
				console.log('Wake Lock was released');
			});
			console.log('Wake Lock is active');
		} catch (err) {
			console.error(`Wake Lock failed: ${err.name}, ${err.message}`);
		}		
	}

	function updateStartTime(event) {
		startTime = moment(event.target.value, timeFormat);
	}

	function updateEndTime(event) {
		endTime = moment(event.target.value, timeFormat);
	}

	function handleArrow(keyCode, time) {
		switch (keyCode) {
			case 38: // Up
				return setSeconds(addMinutes(time, 1), 0);
			case 40: // Down
				return setSeconds(subMinutes(time, 1), 0);
			case 39: // Right
				return setSeconds(addHours(time, 1), 0);
			case 37: // Left
				return setSeconds(subHours(time, 1), 0);
		}
		return time;
	}

	function startTimeKey(event) {
		startTime = handleArrow(event.keyCode, startTime);
	}

	function endTimeKey(event) {
		endTime = handleArrow(event.keyCode, endTime);
	}

	function startTimer() {
		startTime = endTime = setMilliseconds(new Date(), 0);
		timer = setInterval(() => {
			endTime = new Date();
		}, 100);
//		document.documentElement.requestFullscreen();
	}

	function stopTimer() {
		clearInterval(timer);
		endTime = addSeconds(setMilliseconds(endTime, 0), 1);
	}


</script>

<style>
	.container-fluid {
		overflow: hidden;
	}

	input.form-control {
		height: 100%;
		border-radius: 0;
	}

	.time-row, .rate-row {
		height: calc(6vh + 10px);
	}
	.time-row input, .rate-row input {
		font-size: calc(3vh + 10px);
	}

	.duration-row {
		height: calc(40vh - 10px);;
	}
	.duration-row input {
		font-size: calc(20vmin);
	}

	.price-row {
		height: calc(38vh - 10px);;
	}
	.price-row input {
		font-size: calc(15vmin);
	}

	.button-row {
		height: 10vh;
	}
	.button-row button {
		font-size: 4vmin;
		border-radius: 0;
	}
</style>

<div class="container-fluid">
	<div class="row time-row">
		<input type="text" value="{format(startTime, timeFormat)}" on:input="{updateStartTime}" on:keydown="{startTimeKey}" class="col-6 text-center form-control form-control">
		<input type="text" value="{format(endTime, timeFormat)}" on:input="{updateEndTime}" on:keydown="{endTimeKey}" class="col-6 text-center form-control form-control">
	</div>
	<div class="row duration-row">
		<input type="text" value="{durationFormatted}" disabled class="col-12 text-center form-control">
	</div>
	<div class="row rate-row">
		<input type="text" value="x" disabled class="col-3 text-center form-control bg-white">
		<input type="text" bind:value="{hourRate}" class="col-6 text-center form-control">
		<input type="text" bind:value="{currency}" class="col-3 text-center form-control">
	</div>
	<div class="row price-row">
		<input type="text" value="{total} {currency}" disabled class="col-12 text-center form-control">
	</div>
	
	<div class="row button-row">
		<button class="btn btn-success col-6" on:click="{startTimer}">Start</button>
		<button class="btn btn-danger col-6" on:click="{stopTimer}">Stop</button>
	</div>
</div>


